const reportPhoneScamAustralia = {
  slug: 'report-phone-scam-australia',
  title: 'How to report a phone scam in Australia',
  description:
    'Step-by-step: report to Scamwatch, ACMA, your bank, carrier, and WhoDatNumber so others are warned.',
  category: 'guides',
  guideType: 'guide',
  readMinutes: 6,
  partnerTip: 'none',
  relatedSlugs: ['after-a-scam-call', 'phone-scams-community-impact'],
  sections: [
    {
      type: 'paragraph',
      text: 'Reporting helps authorities track trends and may help you access support. Do it even if you did not lose money.',
    },
    {
      type: 'heading',
      level: 2,
      text: '1. Gather details',
    },
    {
      type: 'list',
      items: [
        'Phone number, date/time, what they claimed',
        'Amount lost or accounts accessed',
        'Screenshots of SMS links or emails',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: '2. Report the scam',
    },
    {
      type: 'list',
      items: [
        'Scamwatch (ACCC) — scamwatch.gov.au',
        'ReportCyber — for cyber-enabled fraud',
        'Police — if threats, large loss, or identity theft',
      ],
    },
    {
      type: 'link',
      to: '/learn/regions/au',
      label: 'All Australia official links',
    },
    {
      type: 'heading',
      level: 2,
      text: '3. Contact your bank and telco',
    },
    {
      type: 'paragraph',
      text: 'If money or credentials were involved, call your bank using the number on your card immediately. Ask your mobile provider about blocking and whether they log nuisance calls.',
    },
    {
      type: 'heading',
      level: 2,
      text: '4. Warn the community',
    },
    {
      type: 'paragraph',
      text: 'Search the number on WhoDatNumber and submit a report (sign in required). Choose the closest category and add factual comments — moderation keeps quality high.',
    },
    {
      type: 'lookupCta',
    },
    {
      type: 'link',
      to: '/learn/after-a-scam-call',
      label: 'Secure your accounts after a scam call',
    },
  ],
};

export default reportPhoneScamAustralia;

